import React, { CSSProperties, useState } from "react";
import { cn } from "@/utils/cn";
import { UploadModal } from "./upload-modal";
import { CreateIcon, ImageActiveIcon, ImageIcon, VideoActiveIcon, VideoIcon } from "./assets";
import { useTranslation } from "react-i18next";

interface CreateActorButtonProps {
  className?: string;
  style?: CSSProperties;
  onCreate: () => void;
  iconClassname?: string;
  textClassName?: string;
}

const CreateActorButton: React.FC<CreateActorButtonProps> = ({
  className,
  style,
  onCreate,
  iconClassname,
  textClassName,
}) => {
  const [hoverType, setHoverType] = useState<"image" | "video">("image");
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "group relative select-none cursor-pointer transition-opacity duration-150",
        "bg-[rgba(249,250,251,1)] rounded-md",
        "aspect-[9/16] flex flex-col items-center justify-center",
        className
      )}
      style={style}
    >
      <div
        className={cn(
          "absolute inset-0",
          "flex flex-col gap-1.5",
          "items-center justify-center",
          "border-2 border-dashed border-[rgba(208,213,221,1)]",
          "rounded-md",
          "text-sm text-[rgba(102,112,133,1)] font-medium",
          // "transition-all duration-200",
          "group-hover:opacity-0",
        )}
      >
        <CreateIcon className={cn("w-5 h-5", iconClassname)} />
        <span className={cn(textClassName)}>
          {t("custom_digital_human.create_actor")}
        </span>
      </div>

      {/* 悬停状态 - 显示上传按钮 */}
      <div
        className={cn(
          "absolute inset-0",
          "flex flex-col ",
          "opacity-0 group-hover:opacity-100 rounded-md",
          // 虚线渐变边框
          "hover:rounded-[12px] hover:border-2 hover:border-dashed hover:border-white hover:from-[#667085] hover:to-[#d0d5dd] hover:bg-origin-border",
          hoverType === "image" ? "hover:bg-gradient-to-b" : "hover:bg-gradient-to-t",
        )}
      >
        {/* 上传图像按钮 */}
        <UploadModal
          trigger={
            <div
              className={cn(
                "relative group/upload flex-1 flex flex-col items-center justify-center gap-1.5",
                "rounded-md rounded-b-none",
                "text-sm font-medium text-[rgba(102,112,133,1)]",
                "transition-colors cursor-pointer !bg-white",
                "hover:text-[rgba(52,64,84,1)] ",
              )}
              onMouseEnter={() => setHoverType("image")}
            >
              <div className={cn(
                " flex flex-col items-center justify-center rounded-md absolute inset-0 bg-transparent",
                "hover:bg-[rgba(242,244,247,1)] hover:rounded-b-2xl"
              )}>
                <ImageIcon className={cn("block group-hover/upload:hidden w-5 h-5", iconClassname)} />
                <ImageActiveIcon className={cn("hidden group-hover/upload:block w-5 h-5", iconClassname)} />
                <span className={cn(textClassName)}>{t("custom_digital_human.photo_to_actor")}</span>
              </div>

              {/* 分割线 */}
              <div className="w-full absolute bottom-0 select-none flex justify-center ">
                <div className="h-[1px] w-[80%] bg-gradient-to-r from-transparent via-gray-300 to-transparent select-none" />
              </div>
            </div>
          }
          uploadType="image"
          onCreate={onCreate}
        />

        {/* 上传视频按钮 */}
        <UploadModal
          trigger={
            <div
              className={cn(
                "relative group/upload flex-1 flex flex-col items-center justify-center gap-1.5",
                "rounded-md rounded-t-none",
                "text-sm font-medium text-[rgba(102,112,133,1)]",
                "transition-colors cursor-pointer !bg-white",
                "hover:text-[rgba(52,64,84,1)]",
              )}
              onMouseEnter={() => setHoverType("video")}
            >
              <div className={cn(
                " flex flex-col items-center justify-center rounded-md absolute inset-0 bg-transparent",
                "hover:bg-[rgba(242,244,247,1)] hover:rounded-t-2xl"
              )}>
                <VideoIcon className={cn("block group-hover/upload:hidden w-5 h-5", iconClassname)} />
                <VideoActiveIcon className={cn("hidden group-hover/upload:block w-5 h-5", iconClassname)} />
                <span className={cn(textClassName)}>{t("custom_digital_human.video_to_actor")}</span>
              </div>
            </div>
          }
          uploadType="video"
          onCreate={onCreate}
        />
      </div>
    </div>
  );
};

export { CreateActorButton };
